import Swiper from 'swiper';
// import 'remodal';

// スクロール
var Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	var smoothScrollTriggers = document.querySelectorAll('.anchor');
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
		smoothScrollTrigger.addEventListener('click', function (e) {
			var href = smoothScrollTrigger.getAttribute('href');
			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
			var targetElement = document.getElementById(href.replace('#', ''));
			if (targetElement) {
				e.preventDefault();
				e.stopPropagation();
				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top + 10;
				var startTime = performance.now();
				var loop = function (nowTime) {
					var time = nowTime - startTime;
					var normalizedTime = time / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};
				requestAnimationFrame(loop);
			}
		});
	});

	// スクロールアニメーション;
	funcAnim();
});

window.addEventListener('load', function () {
	// フェーダー
	// LINE UP箇所
	const swiper = document.querySelector('.slide .swiper-container');
	const mySwiper = new Swiper(swiper, {
		effect: 'fade',
		loop: false,
		// watchOverflow: true, // loopと併用不可
		speed: 0,
		autoplay: false,

		on: {
			slideChange: function () {
				// 現在のスライドが最後のスライドかつ、自動再生中の場合に処理を実行
				if (mySwiper.isEnd && mySwiper.autoplay.running) {
					mySwiper.autoplay.stop();
				}
			},
			init: function () {
				// Intersection Observerの設定
				const options = {
					root: null, // ビューポートをルートとする
					rootMargin: '0px',
					threshold: 0.7, // 要素の50%が表示されたら発火
				};

				const observerCallback = (entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							// 対象の要素が表示領域に入った場合 (isIntersecting が true)
							// console.log('Swiperが画面領域に入りました！');
							mySwiper.params.autoplay.delay = 400;
							mySwiper.autoplay.start();

							// 一度発火したら監視を停止したい場合は、以下のコメントを解除
							observer.unobserve(entry.target);
						} else {
							// 要素が画面外に出た場合の処理
							// console.log('Swiperが画面領域から出ました。');
							// mySwiper.autoplay.stop();
						}
					});
				};

				// Intersection Observerのインスタンスを作成
				const observer = new IntersectionObserver(observerCallback, options);

				// 監視対象の要素を取得し、監視を開始
				const targetElement = document.querySelector('.slide');
				if (targetElement) {
					observer.observe(targetElement);
				}
			},
		},
	});

	// コーディネート箇所
	let fader = document.querySelectorAll('.fader');
	for (let i = 0; i < fader.length; i++) {
		const swiper = document.querySelectorAll('.fader .swiper-container')[i];
		const mySwiper = new Swiper(swiper, {
			loop: false,
			// watchOverflow: true, // loopと併用不可
			effect: 'fade',
			speed: 0,
			autoplay: {
				delay: 167,
				disableOnInteraction: false,
			},

			on: {
				click: function (swiper, event) {
					mySwiper.autoplay.start();
					// console.log('CLICK!');
				},

				slideChange: function () {
					// 現在のスライドが最後のスライドかつ、自動再生中の場合に処理を実行
					if (mySwiper.isEnd && mySwiper.autoplay.running) {
						mySwiper.autoplay.stop();

						setTimeout(() => {
							mySwiper.slideTo(0, 0);
						}, 167);
					}
				},
			},
		});

		mySwiper.autoplay.stop();
	}

	let fader2 = document.querySelectorAll('.fader2');
	for (let i = 0; i < fader2.length; i++) {
		const swiper = document.querySelectorAll('.fader2 .swiper-container')[i];
		const mySwiper = new Swiper(swiper, {
			loop: false,
			// watchOverflow: true, // loopと併用不可
			effect: 'fade',
			speed: 0,
			autoplay: {
				delay: 83.3,
				disableOnInteraction: false,
			},

			on: {
				click: function (swiper, event) {
					mySwiper.autoplay.start();
					// console.log('CLICK!');
				},

				slideChange: function () {
					// 現在のスライドが最後のスライドかつ、自動再生中の場合に処理を実行
					if (mySwiper.isEnd && mySwiper.autoplay.running) {
						mySwiper.autoplay.stop();

						setTimeout(() => {
							mySwiper.slideTo(0, 0);
						}, 83.3);
					}
				},
			},
		});

		mySwiper.autoplay.stop();
	}
});

window.addEventListener('scroll', () => {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let myMain = document.querySelectorAll('.area');
	for (let i = 0; i < myMain.length; i++) {
		let rect = myMain[i].getBoundingClientRect();
		let posiTop = rect.top + scrollTop; // ターゲットがブラウザTOPに来たら
		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
		// let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
		let myHeight = myMain[i].clientHeight - 0;
		let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位置
		// ターゲットが来た時ときの動き
		if (scrollTop > posiTop && scrollTop < position_bottom) {
			document.querySelector('.side nav li:nth-child(' + [i + 1] + ')').classList.add('active');
			document.querySelector('.naviMain li:nth-child(' + [i + 1] + ')').classList.add('active');
			// console.log('きた');
		} else {
			// それ以外の動き
			document.querySelector('.side nav li:nth-child(' + [i + 1] + ')').classList.remove('active');
			document.querySelector('.naviMain li:nth-child(' + [i + 1] + ')').classList.remove('active');
		}
	}

	// キービジュアル通過でアイコンclass追加
	let myMain2 = document.querySelectorAll('.showArea');
	for (let i = 0; i < myMain2.length; i++) {
		let rect2 = myMain2[i].getBoundingClientRect();
		let posiTop2 = rect2.top + scrollTop - 0; // ターゲットがブラウザTOPに来たら
		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
		// let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
		let myHeight2 = myMain2[i].clientHeight - 0;
		let position_bottom2 = posiTop2 + myHeight2; // ターゲットが下からスクロールしたときに見える位置

		// ターゲットが来た時ときの動き
		if (scrollTop > posiTop2 && scrollTop < position_bottom2) {
			document.querySelector('.naviMain').classList.add('show');
			// console.log('きた');
		} else {
			// それ以外の動き
			document.querySelector('.naviMain').classList.remove('show');
			// console.log('出た');
		}
	}
});

const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		// root: root,
		rootMargin: '0px 0px -10% 0px',
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
